import { Routes } from '@angular/router';
import { externalRedirectGuard } from './core/guards/external-redirect.guard';
import { DummyComponent } from './shared/components/dummy/dummy.component';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    component: DummyComponent,
    canActivate: [externalRedirectGuard(environment.landingUrl)],
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/pages/reset-password/reset-password').then(
        (m) => m.ResetPasswordComponent
      ),
    title: 'Reset Password',
  },
  {
    path: 'confirm-email-change',
    loadComponent: () =>
      import('./features/auth/pages/confirm-email-change/confirm-email-change').then(
        (m) => m.ConfirmEmailChangeComponent
      ),
    title: 'Confirm Email Change',
  },
  {
    path: '**',
    component: DummyComponent,
    canActivate: [externalRedirectGuard(environment.landingUrl)],
  },
];
